import { render, staticRenderFns } from "./CampaignBannerViewSidebar.vue?vue&type=template&id=b2f7a854&scoped=true&"
import script from "./CampaignBannerViewSidebar.vue?vue&type=script&lang=js&"
export * from "./CampaignBannerViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CampaignBannerViewSidebar.vue?vue&type=style&index=0&id=b2f7a854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f7a854",
  null
  
)

export default component.exports